<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="320"
  >
    <!-- Activador -->
    <template #activator="{ on, attrs }">
      <v-text-field
        v-if="!iconActivator"
        v-model="displayValue"
        :label="label"
        :disabled="disabled"
        :required="required"
        readonly
        outlined
        dense
        v-bind="attrs"
        v-on="on"
      />

      <v-btn
        v-else
        icon
        :disabled="disabled"
        aria-label="Abrir calendario"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-calendar</v-icon>
      </v-btn>
    </template>

    <v-card>

    <v-card-text class="pt-0 pb-0 px-0">
        <!-- Fecha -->
        <div v-if="mode !== 'time'">
          <v-date-picker
            v-model="date"
            locale="es"
            first-day-of-week="1"
            no-title
            scrollable
            color="primary"
          />
        </div>

        <!-- Hora -->
        <div
          v-if="mode !== 'date'"
          class="d-flex justify-center"
        >
          <v-text-field
            v-model="time"
            dense
            type="time"
            hide-details
            suffix="h"
            style="max-width: 120px"
          />
        </div>

      </v-card-text>

      <v-divider />

      <!-- Acciones -->
      <v-card-actions class="justify-end py-1">
        <v-btn text small color="red" @click="menu = false">
          Cancelar
        </v-btn>
        <v-btn
          text
          small
          color="green"
          :disabled="!canConfirm"
          @click="confirm"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: 'Fecha y hora'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'datetime', // 'datetime' | 'date' | 'time'
      validator: v => ['datetime', 'date', 'time'].includes(v)
    },
    hourOnly: {
      type: Boolean,
      default: false
    },
    iconActivator: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      menu: false,
      date: null,
      time: '00:00'
    }
  },

  computed: {
    displayValue() {
      if (this.mode === 'time') {
        return this.time || ''
      }

      if (this.mode === 'date') {
        if (!this.date) return ''
        const [y, m, d] = this.date.split('-')
        return `${d}/${m}/${y}`
      }

      // datetime
      if (!this.date || !this.time) return ''
      const [y, m, d] = this.date.split('-')
      return `${d}/${m}/${y} ${this.time}`
    },

    canConfirm() {
      if (this.mode === 'time') {
        return !!this.time
      } else if (this.mode === 'date') {
        return !!this.date
      } else {
        return !!this.date && !!this.time
      }
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (!val) return

        if (this.mode === 'time') {
          this.time = val
          return
        }

        if (this.mode === 'date') {
          const [d, m, y] = val.split('/')
          this.date = `${y}-${m}-${d}`
          return
        }

        // datetime
        const [fecha, hora] = val.split(' ')
        const [d, m, y] = fecha.split('/')
        this.date = `${y}-${m}-${d}`
        this.time = hora
      }
    }
  },

  methods: {
    confirm() {
      const time = this.hourOnly ? `${this.time.split(':')[0]}:00` : this.time

      if (this.mode === 'time') {
        this.$emit('input', time)
        this.menu = false
        return
      }

      if (!this.date) return

      const [y, m, d] = this.date.split('-')

      if (this.mode === 'date') {
        this.$emit('input', `${d}/${m}/${y}`)
      } else {
        this.$emit('input', `${d}/${m}/${y} ${time}`)
      }

      this.menu = false
    }
  }
}
</script>
